import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { clearSubCategoryDetails } from "./subCategorySlice";
import {
  createSubCategory,
  FindAllActiveCategory,
  getAllSubCategory,
  getSubCategoryByID,
  updateSubCategory,
  updateSubCategoryImage,
} from "./services/subCategory.services";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import { slugify } from "../../_helper/helper";
import FormRichTextField from "../../components/formFields/FormRichTextField";
import FormImageUploadMorden from "../../components/formFields/formImageUploadMorden";

const CreateSubCategory: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const SubCategoryDetail = useAppSelector(
    (state) => state.subCategory.SubCategoryDetail
  );
  const SubCategoryID = useAppSelector((state) => state.muidrawer.data);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [SubCategoryDetail]);

  const loading = useAppSelector((state) => state.subCategory.formloading);
  const CategoriesList = useAppSelector(
    (state) => state.subCategory.CategoriesList
  );

  useEffect(() => {
    return () => {
      dispatch(clearSubCategoryDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    dispatch(FindAllActiveCategory());
    if (SubCategoryID) {
      dispatch(getSubCategoryByID(SubCategoryID));
    }
  }, [SubCategoryID]);

  const handleSubmit = async (values: any) => {
    const ImageData = new FormData();
    const Image =
      values?.Image &&
      typeof values?.Image !== "string" &&
      Array.isArray(values?.Image) &&
      values?.Image?.length > 0
        ? values.Image[0].getRawFile()
        : "";
    try {
      if (!SubCategoryID) {
        const insertPayload = {
          Name: values?.Name ? values?.Name : "",
          SubCategoryURL: values?.SubCategoryURL ? values?.SubCategoryURL : "",
          CategoryID: values?.CategoryID ? values?.CategoryID : "",
          Description: values?.Description ? values?.Description : "",
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(createSubCategory(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            values?.Image &&
            typeof values?.Image !== "string" &&
            Array.isArray(values?.Image) &&
            values?.Image?.length > 0 &&
            response?.payload?.Data?.ID
          ) {
            ImageData.append("SubCategoryImage", Image);
            ImageData.append("ID", response?.payload?.Data?.ID);
            await dispatch(updateSubCategoryImage(ImageData));
          }
          dispatch(closed());
          dispatch(clearSubCategoryDetails());
          dispatch(getAllSubCategory());
        }
      } else {
        const editPayload = {
          ID: SubCategoryID,
          Name: values?.Name ? values?.Name : "",
          SubCategoryURL: values?.SubCategoryURL ? values?.SubCategoryURL : "",
          CategoryID: values?.CategoryID ? values?.CategoryID : "",
          Description: values?.Description ? values?.Description : "",
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateSubCategory(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            values?.Image &&
            typeof values?.Image !== "string" &&
            Array.isArray(values?.Image) &&
            values?.Image?.length > 0
          ) {
            ImageData.append("SubCategoryImage", Image);
            ImageData.append("ID", SubCategoryID);
            await dispatch(updateSubCategoryImage(ImageData));
          }
          dispatch(closed());
          dispatch(clearSubCategoryDetails());
          dispatch(getAllSubCategory());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  const handleCreateSlug = (e: any, formRenderProps: FormRenderProps) => {
    const slug = slugify(e.value);
    formRenderProps.onChange("SubCategoryURL", { value: slug });
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        initialValues={SubCategoryDetail}
        key={formKey}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement style={{ width: "100%" }}>
            <GridLayout
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
              gap={{ rows: 10 }}
              cols={[{ width: "100%" }]}
            >
              <GridLayoutItem
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                <Typography.h4 className="m-0">
                  {SubCategoryID ? "Update Size" : "Add Size"}
                </Typography.h4>
                <Button
                  type="button"
                  fillMode={"flat"}
                  themeColor={"dark"}
                  style={{ marginRight: 4 }}
                  onClick={() => dispatch(closed())}
                >
                  <RxCross1 />
                </Button>
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  name="Name"
                  label="Name"
                  placeholder="Size Name"
                  onChange={(e) => handleCreateSlug(e, formRenderProps)}
                  component={FormTextField}
                  astrike={true}
                  validator={requiredValidator}
                />
                <Field
                  name="SubCategoryURL"
                  label="SubCategory URL"
                  placeholder="SubCategory URL"
                  component={FormTextField}
                  validator={requiredValidator}
                  astrike={true}
                />
                <Field
                  id={"CategoryID"}
                  name={"CategoryID"}
                  label={"Category"}
                  component={FormSelectionField}
                  validator={requiredValidator}
                  astrike={true}
                  options={CategoriesList?.map((Category: any) => {
                    return {
                      value: Category.ID,
                      label: Category.Name,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  name="Description"
                  label="Description"
                  placeholder="Description"
                  component={FormRichTextField}
                  // validator={requiredValidator}
                  // astrike={true}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  justifyContent="start"
                  name={`Image`}
                  label="Client Image"
                  type="file"
                  accept="image/*"
                  alternateName="Client Image"
                  component={FormImageUploadMorden}
                />
              </GridLayoutItem>
              <GridLayoutItem style={{ width: "100%" }}>
                <Field
                  id={"IsActive"}
                  name={"IsActive"}
                  label={"Status"}
                  component={FormSelectionField}
                  validator={requiredValidator}
                  astrike={true}
                  options={STATUSARRAY?.map((status: any) => {
                    return {
                      value: status.value,
                      label: status.label,
                    };
                  })}
                />
              </GridLayoutItem>
              <GridLayoutItem
                colSpan={3}
                style={{
                  marginTop: 20,
                  width: "100%",
                }}
              >
                <ButtonWithLoading
                  label={SubCategoryID ? "Update" : "Create"}
                  type="submit"
                  disabled={!formRenderProps.allowSubmit || loading}
                  loading={loading}
                />

                <Button
                  type="button"
                  fillMode={"outline"}
                  themeColor={"primary"}
                  style={{ marginLeft: 10 }}
                  onClick={handleFormClose}
                >
                  Cancel
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateSubCategory;
